var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmprestimosNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9991 21.4269L17.2187 17.2561V12.3903C17.2187 10.4161 13.224 8.29368 12.1211 7.33905",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9376 13.5858L10.5547 10.8795C10.4427 10.7675 10.3097 10.6787 10.1634 10.6181C10.0171 10.5575 9.86033 10.5263 9.70197 10.5263C9.54361 10.5263 9.3868 10.5575 9.2405 10.6181C9.0942 10.6787 8.96126 10.7675 8.84929 10.8795C8.73731 10.9914 8.64849 11.1244 8.58789 11.2707C8.52728 11.417 8.49609 11.5738 8.49609 11.7322C8.49609 11.8905 8.52729 12.0473 8.58789 12.1936C8.64849 12.3399 8.73731 12.4729 8.84929 12.5848L12.121 16.2922V18.6092C12.121 19.7029 13.6873 21.3897 13.6873 21.3897",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.122 18.6092C12.1256 18.7946 12.0925 18.9788 12.0244 19.1512C11.9563 19.3236 11.8546 19.4808 11.7253 19.6136C11.5959 19.7464 11.4415 19.8521 11.2709 19.9248C11.1004 19.9974 10.9171 20.0354 10.7317 20.0366H2.39024C2.02153 20.0366 1.66791 19.8901 1.40719 19.6294C1.14647 19.3687 1 19.015 1 18.6463V1.96339C1 1.59468 1.14647 1.24107 1.40719 0.980344C1.66791 0.719622 2.02153 0.573151 2.39024 0.573151H10.7317C11.1004 0.573151 11.454 0.719622 11.7148 0.980344C11.9755 1.24107 12.122 1.59468 12.122 1.96339V12.1585",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.86514 13.0205C5.19678 12.8735 4.60608 12.4853 4.20609 11.9301C3.8061 11.3748 3.62491 10.6916 3.69721 10.0111C3.7695 9.33059 4.0902 8.70066 4.59792 8.24186C5.10564 7.78305 5.76473 7.52759 6.44904 7.52436C7.01267 7.51944 7.56368 7.69123 8.02465 8.01558",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.78125 3.12192V4.51216",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.3418 16.561V17.4878",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmprestimosNewIcon);
export default __webpack_public_path__ + "static/media/emprestimos-new-icon.f7c3c38e565eaa9b1b1e015da61b3391.svg";
export { ForwardRef as ReactComponent };